<template>
  <v-navigation-drawer
    color="primary"
    fixed
    app
    class="menu"
    :dark="true"
    v-if="with_company"
  >
    <v-list dense nav class="py-0">
      <v-list-item two-line class="px-2">
        <v-list-item-content>
          <div class="d-flex justify-center py-11">
            <img :src="require('@/assets/img/logo_intlane_cms.svg')" alt="" />
          </div>
          <v-select
            v-model="company_id"
            :items="companies"
            item-text="name"
            item-value="id"
            class="pb-3"
            label="Companies"
            :flat="true"
            background-color="#2AA55E"
            :hide-details="true"
            solo
          ></v-select>
          <v-select
            v-model="region_id"
            :items="regions"
            item-text="name"
            item-value="id"
            class="pb-3"
            :flat="true"
            label="Regions"
            background-color="#2AA55E"
            :hide-details="true"
            solo
          ></v-select>
          <v-select
            v-model="store_id"
            :items="stores"
            item-text="name"
            item-value="id"
            class="pb-3"
            :flat="true"
            background-color="#2AA55E"
            label="Stores"
            :hide-details="true"
            solo
          ></v-select>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list dense nav class="px-0">
      <v-list-item-group :value="selected_menu" class="mt-3 ">
        <h5 class="px-5 subtitle_item">ANALYZE</h5>
        <v-list-item
          class="menu-item mx-0 px-5 opacity_50 py-1"
          v-for="(item, i) in list.filter(item => item.type === 'analyze')"
          :key="'analyze_' + i"
          link
          @click="goToRoute(item, i, 'analyze')"
        >
          <v-list-item-icon align="center">
            <div class="icon">
              <img
                :src="item.icon"
                alt=""
                :class="{ opacity_50: selected !== 'analyze_' + i }"
              />
            </div>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title
              :class="{ opacity_50: selected !== 'analyze_' + i }"
              >{{ item.title }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <h5 class="px-5 subtitle_item pt-4">MANAGE</h5>
        <v-list-item
          class="menu-item mx-0 px-5 opacity_50 py-1"
          v-for="(item, j) in list.filter(item => item.type === 'manage')"
          :key="'manage_' + j"
          link
          @click="goToRoute(item, j, 'manage')"
        >
          <v-list-item-icon align="center">
            <div class="icon">
              <img
                :src="item.icon"
                alt=""
                :class="{ opacity_50: selected !== 'manage_' + j }"
              />
            </div>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title
              :class="{ opacity_50: selected !== 'manage_' + j }"
              >{{ item.title }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <!--    <site-footer></site-footer>-->
  </v-navigation-drawer>
</template>

<script>
import route from "@/router/index";
import { mapActions, mapState } from "vuex";
import SiteFooter from "@/components/layout/footer.vue";
import router from "../../router";

export default {
  components: { SiteFooter },
  created() {
    this.$store.dispatch("Authenticate/me");
    //this.$store.dispatch("Authenticate/me");
  },
  watch: {
    user: {
      async handler(current_user) {
        if (current_user.id) {
          if (current_user.company_id) {
            this.with_company = true;
            await this.getRegions({ company_id: current_user.company_id });
            let company = await this.getCompany(current_user.company_id);
            if (company) {
              this.selectOptions({ company_id: company.id });
              this.companies = [company];
              this.company_id = current_user.company_id;
            }
          }
          if (!current_user.company_id) {
            this.with_company = false;
            this.$router.push("/admin/not_found").catch(null);
          }
        }
      },
      immediate: true
    },
    region_id: {
      async handler(current_region) {
        if (current_region) {
          this.selectOptions({ region_id: current_region, store_id: null });
          this.store_id = null;
          await this.getStores({ region_id: current_region });
        }
      },
      immediate: true
    },
    store_id: {
      async handler(current_store) {
        if (current_store) {
          this.selectOptions({ store_id: current_store });
        }
      },
      immediate: true
    }
  },
  data: () => ({
    with_company: false,
    selected: 0,
    region_id: null,
    store_id: null,
    companies: [],
    company_id: null
  }),
  computed: {
    role_name() {
      return this.user && this.user.role ? this.user.role.label : "";
    },
    ...mapState({
      list: state => state.Menu_enterprise.list,
      selected_menu: state => state.Menu_enterprise.selected_menu,
      user: state => state.Authenticate.user,
      regions: state => state.Regions.list,
      stores: state => state.Stores.list
    })
  },
  methods: {
    ...mapActions({
      getCompany: (dispatch, arg) => dispatch("Companies/show", arg),
      getRegions: (dispatch, arg) => dispatch("Regions/getListAll", arg),
      getStores: (dispatch, arg) => dispatch("Stores/getListAll", arg),
      selectOptions: (dispatch, arg) => dispatch("Menu_enterprise/selectItem", arg),
    }),
    goToRoute(item, index, type) {
      this.selected = type + "_" + index;
      route.push(item.link).catch(() => {});
    },
    editProfile() {
      this.$router.push("/admin/profile");
    }
  }
};
</script>
